import React from 'react';
import Container from '../../../../components/Container';
import styles from './Desktop.module.css';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import Content from '../../../../components/Content';
import cardLogin from '../../../../assets/images/serverApp/cardLogin.png';
import keyboardLogin from '../../../../assets/images/serverApp/keyPadLogin.png';
import activateArrow from '../../../../assets/images/login/activateArrow.png';
import constants from '../../../../globalization';
import NumberKeypad from '../../../../components/NumberKeypad';
import classNames from 'classnames';

export default function Desktop(props) {
  const { popup, password, closePopup, login, isArrowDisabled, scanCard, isCardLogin, onLoginModeChange, onKeyPress, supportsLoginUsingCard, disableLoginWithKeypad } = props;

  const getPopupStyle = () => {
    let popupStyle = {};
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "60%" };
    } else if (popup && popup.type === "popup") {
      popupStyle = { width: "30%" };
    }
    return popupStyle;
  }

  return (
    <Container style={styles.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()}>
        <PopupContent {...popup} />
      </Popup>
      <Content style={styles.content}>
          {isCardLogin ? (
             <div className={styles.headerView}>
              <p className={styles.activationText}>Please Use Employee Card To Login</p>
              <div onClick={scanCard} className={styles.swipeCard}>{constants.tapToSwipeCard}</div>
            {disableLoginWithKeypad ? null : (<div className={styles.touchKeypad} onClick={onLoginModeChange}>
              <img src={keyboardLogin} className={styles.imageSize} alt="card" />
            </div>)}
          </div>
          ) : (
            <div className={styles.headerView}>
              <div>
                <p className={styles.activationText}>Please Enter Your Login Id</p>
              </div>
              <div className={styles.textInputWrapper}>
                <input type="text" readOnly value={password} className={styles.textInput} />
                <button
                  className={classNames({ [styles.enabledArrowBtn]: isArrowDisabled(), [styles.disabledArrowBtn]: !isArrowDisabled() })}
                  type="submit"
                  disabled={isArrowDisabled()}
                  onClick={() => login()} >
                  <img src={activateArrow} className={styles.arrowImg} alt="" />
                </button>
                <button type="reset" className={styles.clearBtn} onClick={() => onKeyPress('', 'reset')}>X</button>
              </div>
              <NumberKeypad onClick={(value, type) => onKeyPress(value, type)} needDecimal={false} keypadKeyStyle={styles.keypadKeyStyle} size="medium" />
          {supportsLoginUsingCard ? (<div className={styles.touchKeypad} onClick={onLoginModeChange}>
            <img src={cardLogin} className={styles.imageSize} alt="card" />
          </div>) : null}
          </div>
          )}
      </Content>
    </Container>
  )
}